export interface CertificationForm {
  Code: string;
  Form: any;
  Key: number;
  Row: any;
}
